import { Box, FlexLayout, H3, H4 } from '@deity/falcon-ui';
import type React from 'react';
import ReactJson from 'react-json-view';
import type { IContainerChildrenProps } from 'utils';

interface IEntityJSONViewerProps {
  name: string;
  description?: string;
  data: JSON;
}

const EntityJSONViewer: React.FC<IEntityJSONViewerProps & IContainerChildrenProps> = ({
  name,
  description,
  data,
  children
}) => (
  <Box p="xxl">
    <FlexLayout pb="xxl" justifyContent="space-between" alignItems="center">
      <Box>
        <H4 fontSize="xll" pt="xss" pb="xss" fontWeight="normal" mr="lg" border="regular" borderColor="transparent">
          {name}
        </H4>
        <H3 color="secondary">{description}</H3>
      </Box>
      {children && children}
    </FlexLayout>
    <H4 fontWeight="bold" mb="xs">
      JSON Schema
    </H4>
    <ReactJson src={data} name={name} theme="ashes" collapseStringsAfterLength={18} />
  </Box>
);

export default EntityJSONViewer;
